import script from "./GgmsBasicEmailParts.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsBasicEmailParts.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsBasicEmailParts.vue?vue&type=style&index=0&id=f21cf212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f21cf212"]])

export default __exports__